<ng-container *ngIf="!isLandingPage">
  <ds-header
    [navBarRef]="navBar"
    appName="{{ title }}"
    [userInfo]="userInfo()"
    [themeSwitch]="true"
  >
  </ds-header>
</ng-container>

<div class="d-flex">
  <ng-container *ngIf="!isLandingPage && !isUnitUpdate">
    <div class="nav-bar-wrapper position-sticky">
      <ds-navigation-bar
        #navBar
        [items]="navigationItems()"
        [isExpanded]="true"
      ></ds-navigation-bar>
    </div>
  </ng-container>

  <main class="container-fluid py-6x">
    <router-outlet></router-outlet>
  </main>
</div>


